if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    getNumberOfPages() {
      const uploadInputs = document.querySelectorAll('input[name^="properties[Upload_"]');
      console.log('Upload inputs found:', uploadInputs.length);
      
      const filledUploadInputs = Array.from(uploadInputs).filter(input => input.value);
      console.log('Filled upload inputs:', filledUploadInputs.length);
      
      return Math.max(filledUploadInputs.length, 1);
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      console.log('Form submission started');
      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      const deliverySelect = document.querySelector('.label-3');
      const deliveryOption = deliverySelect ? deliverySelect.value : null;
      console.log('Delivery option:', deliveryOption);
      
      try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        const newItem = {
          properties: {
            Lieferoption: deliveryOption,
           // Versand: deliveryOption
          }
        };

        await window.cartValidator.validateBeforeAdd(cart.items, newItem);

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        const quantity = parseInt(formData.get('quantity') || '1');
        const variantId = formData.get('id');
        
        if (deliveryOption) {
          formData.set('properties[Lieferoption]', deliveryOption);
          // formData.set('properties[Versand]', deliveryOption);
          
          // Handle page count properties for postal delivery
          if (deliveryOption === 'PDF & Original per Post') {
            const numberOfPages = this.getNumberOfPages();
            console.log('Number of pages:', numberOfPages);
            const pricePerPage = 9.90;
            const totalCostPerPage = pricePerPage * numberOfPages;

            formData.set('properties[_page_count]', numberOfPages.toString());
            formData.set('properties[_cost_per_page]', pricePerPage.toString());
            formData.set('properties[_additional_cost_total]', totalCostPerPage.toString());
          }
        }

        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        
        console.log('Sending request to add to cart');
        const response = await fetch(window.routes.cart_add_url, {
          ...config,
          body: formData
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const parsedResponse = await response.json();
        console.log('Add to cart response:', parsedResponse);
        document.dispatchEvent(new CustomEvent('cart:add-complete'));

        if (parsedResponse.status) {
          this.handleErrorMessage(parsedResponse.description);
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        }

        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cartNotification.renderContents(parsedResponse) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cartNotification.renderContents(parsedResponse);
        }

      } catch (error) {
        console.error('Error in form submission:', error);
        this.handleErrorMessage(error.message);
      } finally {
        this.submitButton.classList.remove('loading');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}